var EvalService = /** @class */ (function () {
    function EvalService() {
        this.chars = {
            '?': {
                type: 'Conditional',
                value: '?',
                asso: 'left',
                prec: 1,
            },
            ':': {
                type: 'Conditional',
                value: ':',
                asso: 'left',
                prec: 1,
            },
            '+': {
                type: 'Operator',
                value: '+',
                asso: 'left',
                prec: 2,
            },
            '-': {
                type: 'Operator',
                value: '-',
                asso: 'left',
                prec: 2,
            },
            '*': {
                type: 'Operator',
                value: '*',
                asso: 'left',
                prec: 3,
            },
            '%': {
                type: 'Operator',
                value: '%',
                asso: 'left',
                prec: 3,
            },
            '/': {
                type: 'Operator',
                value: '/',
                asso: 'left',
                prec: 3,
            },
            '^': {
                type: 'Operator',
                value: '^',
                asso: 'right',
                prec: 4,
            },
            '===': {
                type: 'Operator',
                value: '===',
                asso: 'equel',
                prec: 1,
            },
            '!==': {
                type: 'Operator',
                value: '!==',
                asso: 'notEqual',
                prec: 1,
            },
            '>=': {
                type: 'Operator',
                value: '>=',
                asso: 'GreaterThanOrEqual ',
                prec: 1,
            },
            '<=': {
                type: 'Operator',
                value: '<=',
                asso: 'lessThanOrEqual ',
                prec: 1,
            },
            '>': {
                type: 'Operator',
                value: '>',
                asso: 'greaterThan',
                prec: 1,
            },
            '<': {
                type: 'Operator',
                value: '>',
                asso: 'lessThan ',
                prec: 1,
            },
            '&&': {
                type: 'Operator',
                value: '&&',
                asso: 'and ',
                prec: 1,
            },
            '||': {
                type: 'Operator',
                value: '||',
                asso: 'or',
                prec: 1,
            },
            '!': {
                type: 'Operator',
                value: '!',
                asso: 'not',
                prec: 5,
            },
            includes: {
                type: 'function',
                value: 'includes',
                asso: 'includes',
                prec: 6,
            },
            indexOf: {
                type: 'function',
                value: 'indexOf',
                asso: 'indexOf',
                prec: 6,
            },
            'JSON.stringify': {
                type: 'function',
                value: 'JSON.stringify',
                asso: 'JSON.stringify',
                prec: 6,
            },
            '.rsGetValidator': {
                type: 'function',
                value: '.rsGetValidator',
                asso: 'rsGetValidator',
                prec: 6,
            },
            number: function (n) {
                //  if (!isNaN(n) && isFinite(n)) {
                return {
                    type: 'Literal',
                    value: n,
                };
                // }
            },
            '(': {
                type: 'Left Parenthesis',
                value: '(',
            },
            ')': {
                type: 'Right Parenthesis',
                value: ')',
            },
        };
    }
    EvalService.prototype.isConditional = function (_string) {
        return this.test(_string, ['?', ':']);
    };
    EvalService.prototype.test = function (_string, _array) {
        for (var i = 0; i < _array.length; i++) {
            if (_string === _array[i]) {
                return true;
            }
        }
        return false;
    };
    EvalService.prototype.isDigit = function (_string) {
        return this.test(_string, ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.']);
    };
    EvalService.prototype.isOperator = function (_string) {
        return this.test(_string, ['+', '-', '*', '/', '%', '^', '===', '!==', '>=', '<=', '>', '<', '&&', '||', '!']);
    };
    EvalService.prototype.isPars = function (s) {
        return this.test(s, ['(', ')']);
    };
    EvalService.prototype.isFunction = function (s) {
        return this.test(s, ['includes', 'indexOf', 'JSON.stringify', '.rsGetValidator']);
    };
    EvalService.prototype.tokenize = function (strng) {
        strng = strng.replace(/\?\./g, '#rsOptionalChaining#.');
        strng = strng.replace(/\?\[/g, '#rsOptionalChaining#[');
        strng = strng.replace(/&amp;&amp;/g, '&&');
        strng = strng.replace(/'/g, '"');
        Object.keys(this.chars).forEach(function (key) {
            if (key === '-') {
                strng = strng
                    .split(' ' + key + ' ')
                    .join('###############separator########Minus###############separator########');
            }
            else if (key === '!==') {
                strng = strng.split(key).join('###############separator########NOTEqualTo###############separator########');
            }
            else {
                strng = strng.split(key).join('###############separator########' + key + '###############separator########');
            }
        });
        strng = strng.replace(/Minus/g, ' - ');
        strng = strng.replace(/NOTEqualTo/g, '!==');
        var str = strng.replace(/ /g, ' ').split('###############separator########');
        var out = [];
        var temp = '';
        for (var i = 0; i < str.length; i++) {
            if (str[i]) {
                if (str[i].indexOf('"') >= 0 && str[i].lastIndexOf('"') > str[i].indexOf('"') && temp === '') {
                    temp += str[i];
                    out.push(this.chars['number'](JSON.parse(temp)));
                    temp = '';
                }
                else if (str[i].indexOf('"') >= 0 && str[i].lastIndexOf('"') === str[i].indexOf('"') && temp === '') {
                    temp += str[i];
                }
                else if (str[i].lastIndexOf('"') < 0 && temp !== '') {
                    temp += str[i];
                }
                else if (str[i].lastIndexOf('"') > 0 && temp !== '') {
                    temp += str[i];
                    temp = temp.replace(/&nbsp;/g, ' ');
                    out.push(this.chars['number'](JSON.parse(temp)));
                    temp = '';
                }
                else {
                    if (str[i].indexOf('&nbsp;') >= 0) {
                        str[i] = str[i].replace(/&nbsp;/g, '');
                    }
                    str[i] = str[i].trim();
                    if (str[i].trim().length > 0 &&
                        !this.isFunction(str[i]) &&
                        !this.isOperator(str[i]) &&
                        !this.isConditional(str[i]) &&
                        !this.isPars(str[i])) {
                        if (str[i].indexOf('model.') >= 0) {
                            str[i] = str[i].replace(/ /g, '');
                            out.push(this.chars['number'](this.getDescendantProp(str[i])));
                        }
                        else {
                            var val = str[i];
                            if (str[i].trim() !== 'undefined' && str[i].trim() !== 'null') {
                                if (str[i].indexOf('-') === -1) {
                                    val = JSON.parse(str[i]);
                                }
                                out.push(this.chars['number'](val));
                            }
                            if (str[i].trim() === 'undefined') {
                                out.push(this.chars['number'](undefined));
                            }
                            else if (str[i].trim() === 'null') {
                                out.push(this.chars['number'](null));
                            }
                        }
                    }
                    else if (this.isOperator(str[i]) || this.isConditional(str[i]) || this.isFunction(str[i])) {
                        if (str[i] == '-' && str[i - 1].indexOf('"') > -1) {
                            temp += '-';
                        }
                        else {
                            out.push(this.chars[str[i]]);
                        }
                    }
                    else if (this.isPars(str[i])) {
                        if (str[i] == '(') {
                            out.push(this.chars['(']);
                        }
                        else {
                            out.push(this.chars[')']);
                        }
                    }
                }
            }
        }
        return out;
    };
    EvalService.prototype.c = function (token) {
        var output = [];
        var stack = [];
        for (var i = 0; i < token.length; i++) {
            var x = token[i];
            var last = stack.length ? stack[stack.length - 1] : false;
            if (x.type == 'Literal') {
                output.push(x);
            }
            else if (x.type == 'Operator' || x.type == 'Conditional' || x.type == 'function') {
                while (last && last.value != '(' && (x.prec < last.prec || (x.asso == 'left' && x.prec == last.prec))) {
                    output.push(stack.pop());
                    last = stack.length ? stack[stack.length] : false;
                }
                stack.push(x);
            }
            else if (x.type == 'Left Parenthesis') {
                stack.push(x);
            }
            else if (x.type == 'Right Parenthesis') {
                while (last && last.value != '(') {
                    output.push(stack.pop());
                    last = stack.length ? stack[stack.length - 1] : false;
                }
                stack.pop();
            }
        }
        return output.concat(stack.reverse());
    };
    EvalService.prototype.t = function (a) {
        var x = [];
        for (var i = 0; i < a.length; i++) {
            if (a[i].type == 'Literal') {
                x.push(a[i].value);
            }
            else if (a[i].type == 'Operator' || a[i].type == 'Conditional' || a[i].type == 'function') {
                switch (a[i].value) {
                    case '+': {
                        if (typeof x[x.length - 2] !== 'string' && typeof x[x.length - 1] !== 'string') {
                            x[x.length - 2] = parseFloat(((x[x.length - 2] * 10000 + x[x.length - 1] * 10000) / 10000).toString());
                        }
                        else {
                            x[x.length - 2] = x[x.length - 2] + x[x.length - 1];
                        }
                        x.pop();
                        break;
                    }
                    case '-': {
                        x[x.length - 2] = parseFloat(((x[x.length - 2] * 10000 - x[x.length - 1] * 10000) / 10000).toString());
                        x.pop();
                        break;
                    }
                    case '*': {
                        x[x.length - 2] = parseFloat((x[x.length - 2] * x[x.length - 1]).toString());
                        x.pop();
                        break;
                    }
                    case '/': {
                        x[x.length - 2] = parseFloat((x[x.length - 2] / x[x.length - 1]).toString());
                        x.pop();
                        break;
                    }
                    case '%': {
                        x[x.length - 2] = parseFloat((x[x.length - 2] % x[x.length - 1]).toString());
                        x.pop();
                        break;
                    }
                    case '^': {
                        x[x.length - 2] = parseFloat(Math.pow(x[x.length - 2], x[x.length - 1]).toString());
                        x.pop();
                        break;
                    }
                    case '===': {
                        x[x.length - 2] = x[x.length - 2] === x[x.length - 1];
                        x.pop();
                        break;
                    }
                    case '!==': {
                        x[x.length - 2] = x[x.length - 2] !== x[x.length - 1];
                        x.pop();
                        break;
                    }
                    case '>': {
                        x[x.length - 2] = x[x.length - 2] > x[x.length - 1];
                        x.pop();
                        break;
                    }
                    case '<': {
                        x[x.length - 2] = x[x.length - 2] < x[x.length - 1];
                        x.pop();
                        break;
                    }
                    case '<=': {
                        x[x.length - 2] = x[x.length - 2] <= x[x.length - 1];
                        x.pop();
                        break;
                    }
                    case '>=': {
                        x[x.length - 2] = x[x.length - 2] >= x[x.length - 1];
                        x.pop();
                        break;
                    }
                    case '&&': {
                        x[x.length - 2] = x[x.length - 2] && x[x.length - 1];
                        x.pop();
                        break;
                    }
                    case '||': {
                        x[x.length - 2] = x[x.length - 2] || x[x.length - 1];
                        x.pop();
                        break;
                    }
                    case '!': {
                        x[x.length - 1] = !x[x.length - 1];
                        break;
                    }
                    case '?': {
                        x[x.length - 2] = x[x.length - 2] ? x[x.length - 1] : false;
                        x.pop();
                        break;
                    }
                    case ':': {
                        x[x.length - 2] = x[x.length - 2] !== false ? x[x.length - 2] : x[x.length - 1];
                        x.pop();
                        break;
                    }
                    case 'includes': {
                        x[x.length - 2] = x[x.length - 2] ? x[x.length - 2].includes(x[x.length - 1]) : false;
                        x.pop();
                        break;
                    }
                    case 'indexOf': {
                        x[x.length - 2] = x[x.length - 2] ? x[x.length - 2].indexOf(x[x.length - 1]) : -1;
                        x.pop();
                        break;
                    }
                    case 'JSON.stringify': {
                        x[x.length - 1] = JSON.stringify(x[x.length - 1]);
                        break;
                    }
                    case '.rsGetValidator': {
                        x[x.length - 2] = this.splitFuncction(x[x.length - 2], x[x.length - 1]);
                        x.pop();
                        break;
                    }
                }
            }
        }
        return x.length ? x[0] : 0;
    };
    EvalService.prototype.splitFuncction = function (data, value) {
        var type = value.toString();
        // if (type && type.length > 0) {
        //   type = JSON.parse(type[1]);
        // } else if (value.indexOf('.') === 0) {
        //   type = value.replace(/\./g, '');
        // }
        if (data && data.validator) {
            var validator_1 = data.validator;
            var argumentList_1 = validator_1.match(/\[(.*?)\]/g);
            if (argumentList_1) {
                argumentList_1.forEach(function (key) {
                    validator_1 = validator_1.split(key).join('###############separator########');
                });
            }
            validator_1 = validator_1.split(',');
            var ind_1 = -1;
            var validatorObj_1 = {};
            validator_1.forEach(function (key) {
                var modifyKey = key.trim().replace(/###############separator########/g, '');
                if (key.indexOf('###############separator########') > -1) {
                    ind_1++;
                    validatorObj_1[modifyKey] = modifyKey + argumentList_1[ind_1];
                }
                else {
                    validatorObj_1[modifyKey] = modifyKey;
                }
            });
            return validatorObj_1[type];
        }
        return undefined;
    };
    EvalService.prototype.Eval = function (n) {
        var x = this.tokenize(n);
        var y = this.c(x);
        var z = this.t(y);
        return z;
    };
    EvalService.prototype.parseData = function (template) {
        var _this = this;
        return template.replace(/\${(.*?)}/g, function (match) {
            var path = match.substr(2, match.length - 3).trim();
            return _this.Eval(path);
        });
    };
    EvalService.prototype.parseString = function (template, data) {
        this.dataResponce = data;
        return this.Eval(template);
    };
    EvalService.prototype.getDescendantProp = function (desc) {
        try {
            var q = desc.replace("model.", '');
            var obj = this.dataResponce;
            var key = q.split('[').join('.').split(']').join('').split('.');
            while (key.length) {
                var value = key.shift();
                if (value) {
                    var keyValue = value.replace(/#rsOptionalChaining#/g, '');
                    obj = obj[keyValue];
                    if (value.indexOf('#rsOptionalChaining#') > 0 && !obj) {
                        break;
                    }
                }
                else {
                    break;
                }
            }
            return obj;
        }
        catch (err) {
            throw Error(err + ' at ' + desc);
        }
        //return desc
    };
    EvalService.prototype.parseTpl = function (template, data) {
        this.dataResponce = data;
        var htmlResponse = this.parseData(template);
        return htmlResponse;
    };
    EvalService.prototype.compileRsIfElse = function (content) {
        var _this = this;
        var template = content.replace(/\n/g, '\\n').replace(/\r/g, '\\r').split(/\s+/);
        var ifStatementArray = [];
        template.forEach(function (element, index) {
            if (element === 'rsIfBlock') {
                var closingIndex = _this.findClosingBracketMatchIndex(template, index);
                console.log(closingIndex);
                ifStatementArray.push({
                    start: index,
                    end: closingIndex,
                });
            }
        });
        ifStatementArray = ifStatementArray.reverse();
        ifStatementArray.forEach(function (item, index) {
            _this.parseElseIf(item, template);
        });
        return template
            .join(' ')
            .replace(/\\n/g, '\n')
            .replace(/\\r/g, '\r')
            .replace(/> /g, '>')
            .replace(/{%/g, '')
            .replace(/%}/g, '')
            .replace(/{{####ifElseData####}}/g, '');
    };
    EvalService.prototype.parseElseIf = function (cordinate, template) {
        var statementArray = [];
        for (var i = cordinate.start; i < cordinate.end; i++) {
            statementArray.push(template[i]);
        }
        statementArray = statementArray.join(' ').split('{%').join('%}').split('%}');
        var stringData = '';
        statementArray.every(function (str, i) {
            if (i % 2 === 0) {
                var cond = statementArray[i];
                cond = cond.trim().split(' ');
                if (cond[1] === 'true' || cond[0] === 'rsElse') {
                    stringData = '' + statementArray[i + 1];
                    return false;
                }
            }
            return true;
        });
        template.forEach(function (str, i) {
            if (i >= cordinate.start && i <= cordinate.end) {
                // if (template[i].indexOf('{{####ifElseData####}}') === -1) {
                template[i] = '';
                // }
            }
        });
        template[cordinate.start - 1] =
            template[cordinate.start - 1].replace(/{%/g, '') + '{{####ifElseData####}}' + stringData;
        template[cordinate.end + 1] = template[cordinate.end + 1].replace(/%}/g, '');
    };
    EvalService.prototype.findClosingBracketMatchIndex = function (str, pos) {
        var depth = 1;
        for (var i = pos + 1; i < str.length; i++) {
            switch (str[i]) {
                case 'rsIfBlock':
                    depth++;
                    break;
                case 'rsEndIfBlock':
                    if (--depth == 0) {
                        return i;
                    }
                    break;
            }
        }
        return -1;
    };
    EvalService.prototype.rsUndefinedSafe = function (template) {
        return template.replace(/rsUndefinedSafe\((.*?)(?=)\)/g, function (valStr) {
            var updatedVal = '';
            var value = valStr.substring(16, valStr.length - 1);
            if (value === 'undefined' || value === 'null') {
                updatedVal = '';
            }
            else {
                updatedVal = value;
            }
            return updatedVal;
        });
    };
    return EvalService;
}());
export { EvalService };
//# sourceMappingURL=eval.js.map